import React, { useState } from 'react'
import classes from "./style.module.scss";

const ResourceBrief = (props) => {
    const { resourseInfo } = props
    return (
        <>
            <div className={`${classes.resourceCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-4'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>
                            Description
                        </div>
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.fullWidthInfoCategory}`}>
                            <div className={`${classes.infoValue}`}>{resourseInfo?.description}</div>
                        </div>
                    </div>
                    {/* <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.fullWidthInfoCategory}`}>
                            <div className={`${classes.infoLabel}`}>Specifications</div>
                            <div className={`${classes.infoValue}`}>
                                <div>Material: Semi-Metallic</div>
                                <div>Dimensions: Length: 175mm, </div>
                                <div>Width: 65mm, </div>
                                <div>Thickness: 18mm</div>
                                <div>Weight: 2.5 kg per set</div>
                                <div>Fitment: Direct replacement for OEM part numbers 12345-AB, 12345-AC</div>
                            </div>
                        </div>
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.fullWidthInfoCategory}`}>
                            <div className={`${classes.infoLabel}`}>Features</div>
                            <div className={`${classes.infoValue}`}>
                                <div>High heat resistance</div>
                                <div>Low dust formula</div>
                                <div>Quiet operation</div>
                                <div>Long-lasting durability</div>
                            </div>
                        </div>
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.fullWidthInfoCategory}`}>
                            <div className={`${classes.infoLabel}`}>Installation Instructions</div>
                            <div className={`${classes.infoValue}`}>
                                <div>Ensure the vehicle is on a flat surface and engage the parking brake.</div>
                                <div>Remove the wheel to access the brake assembly.</div>
                                <div>Remove the old brake pads from the caliper.</div>
                                <div>Clean the caliper and check for any damage.</div>
                                <div>Install the new brake pads into the caliper.</div>
                                <div>Reinstall the wheel and lower the vehicle.</div>
                                <div>Test the brakes to ensure proper installation.</div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default ResourceBrief;